// extracted by mini-css-extract-plugin
export default {"container":"Oj5H73","share-icons":"Tflbyk","shareIcons":"Tflbyk","share-icon":"nyHAVu","shareIcon":"nyHAVu"};